export const GLOBAL_PLACE_REWARDS = 'global.placeRewards';
export const CHECKOUT_BAGPAGE = 'checkout.bagPage';

const WalletLabels = {
  checkout: {
    bagPage: {
      lbl_coupon_collapsible_header: 'Rewards & Offers',
    },
  },
  global: {
    placeRewards: {
      lbl_my_wallet_heading: 'MY WALLET',
    },
  },
};

export default WalletLabels;
